export default "__VITE_ASSET__FFXaPBBg__"